import { Auth, Action, ActionTypes } from "../actions";
import { APP_TOKEN_NAME } from "../utils/AxiosToken";
// import {CandidateInterface} from '../interfaces/candidatesInterfaces'
// default state
const defaultState = {
  loading: true,
  isAuthenticated: false,
  token: "",
  user: null,
} as Auth;

/**
 * this is the comment that im using from my brand new keyboard and i like i very mutch hahah this is awesome and coool
 * @param state
 * @param action
 * @returns
 */
export const authReducer = (state: Auth = defaultState, action: Action) => {
  switch (action.type) {
    case ActionTypes.CLEAN_USER_DETAILS:
      return {
        ...defaultState,
      };

    case ActionTypes.USER_LOGIN_SUCCESS_DATA:
      return {
        ...state,
        token: action.payload.token,
        user: action.payload.data[0],
        isAuthenticated: true,
        loading: false,
      } as Auth;

    case ActionTypes.LOGOUT:
      localStorage.removeItem(APP_TOKEN_NAME);
      return {
        ...defaultState,
        loading: false,
      } as Auth;
    default:
      return state;
  }
};
